import React from 'react'
import { CiSearch } from 'react-icons/ci'

const Search = ({ query, setquery, placeholder, inputWidth }) => {
  return (
    <div className="w-full flex items-center mb-4">
      <div 
        className={`relative group ${inputWidth ? `w-[${inputWidth}]` : 'w-full max-w-md'}`}
      >
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-slate-600 group-focus-within:text-white transition-colors">
          <CiSearch className="w-5 h-5" />
        </div>
        <input
          type="text"
          value={query}
          onChange={(event) => setquery(event.target.value)}
          className="input-field pl-10"
          placeholder={placeholder || "Search..."}
        />
      </div>
    </div>
  )
}

export default Search
